import { endpoints } from "@/hooks/endpoints";
import { getToken } from "@/hooks/utils";
import { useAppDispatch } from "@/store/hooks";
import { setHostname } from "@/store/slices/hostnameSlice";
import { useQuery } from "@tanstack/react-query";
import Animation from "../Animation";
import Spinner from "../Spinner";

const getMyTeachers = async () => {
  const res = await fetch(endpoints.getMyTeachers, {
    headers: {
      "Content-Type": "application/json",
      Authorization: getToken(),
    },
  });
  const response = await res.json();
  if (!res.ok) {
    throw new Error(response.message);
  }
  return response.data;
};

const MyTeachers = () => {
  const dispatch = useAppDispatch();

  const {
    data: teachers,
    isPending,
    error,
  } = useQuery({
    queryKey: ["myTeachers"],
    queryFn: () => getMyTeachers(),
  });

  return (
    <Animation>
      <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-(--secondary-color)/10 to-yellow-50 py-4">
        <h1 className="text-3xl font-bold text-center mt-4 mb-8">منصاتي</h1>
        <div className="container mx-auto px-4">
          {isPending && (
            <div className="flex items-center justify-center w-full py-10">
              <Spinner />
            </div>
          )}

          {!!error && (
            <h2 className="text-xl font-semibold mb-4 text-center mx-auto">
              حدث خطأ، تواصل مع الدعم الفني
            </h2>
          )}

          {teachers?.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 pb-8">
              {teachers.map((teacher) => (
                <button
                  key={teacher.portal}
                  className="no-underline outline-none bg-transparent hover:cursor-pointer"
                  onClick={() => dispatch(setHostname(teacher.portal))}
                >
                  <div className="bg-white rounded-2xl shadow-md">
                    <img
                      src={teacher.img}
                      alt={teacher.name}
                      loading="lazy"
                      className="w-full aspect-square rounded-lg mx-auto mb-4"
                    />
                    <h2 className="text-xl font-semibold p-4 mx-auto w-fit">
                      {teacher.name}
                    </h2>
                  </div>
                </button>
              ))}
            </div>
          )}

          {teachers?.length == 0 && (
            <h2 className="text-xl font-semibold mb-4 text-center mx-auto">
              أنت لست مشترك مع اي من مدرسينا
            </h2>
          )}
        </div>
      </div>
    </Animation>
  );
};

export default MyTeachers;
